import styled from 'styled-components';

import FieldLabel from 'components/shared/form/FieldLabel';
import { BodySmall } from 'styles/typography';

type Props = {
  title?: string;
  badge?: React.ReactNode;
  error?: string;
  disabled?: boolean;
  visible?: boolean;
  children: React.ReactNode;
  $containerWidth?: string;
};

export default function InputGroup(props: Props) {
  const { title, visible, children, error, badge, $containerWidth, ...rest } = props;
  return (
    <InputGroupContainer $visible={visible ?? true} $width={$containerWidth} {...rest}>
      <TitleContainer>
        {!!title && <FieldLabel name={title}>{title}</FieldLabel>}
        {badge}
      </TitleContainer>
      <div>{children}</div>
      <ErrorMessageContainer>{!!error && <RedBodySmall>{error}</RedBodySmall>}</ErrorMessageContainer>
    </InputGroupContainer>
  );
}

const InputGroupContainer = styled.div<{ $visible: boolean; $width?: string }>`
  width: ${({ $width }) => $width ?? '100%'};

  ${({ $visible }) => !$visible && `display: none;`}
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  line-height: 16px;
  color: var(--black-75);
`;

const ErrorMessageContainer = styled.div`
  margin-top: 6px;
  min-height: 20px;
  white-space: pre-line;
`;

const RedBodySmall = styled(BodySmall)`
  color: var(--accent-red);
  margin-bottom: 15px;
`;

export const InlineInputGroups = styled.div`
  flex: 1;
  flex-basis: 100%;
  display: flex;
  align-items: flex-end;
  & > * {
    flex: 1;
    margin-right: 9px;
    &:last-child {
      margin-right: 0;
    }
  }
`;
